import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { LoaderService } from 'src/app/service/loader.service';
import { HttpClientService } from 'src/app/service/http-client.service';
import { LoginPostRequest } from 'src/app/interfaces/login';
import { SessionService } from 'src/app/service/session.service';
import { StaffService } from 'src/app/service/staff.service';

import { BaseService } from 'src/app/service/base.service';
import { Utils } from 'src/app/const/func-util';

declare var $;
@Component({
  selector: 'app-com-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {

  @ViewChild('companyCodeEm', { static: false }) companyCodeEm: ElementRef;
  @ViewChild('loginIdEm', { static: false }) loginIdEm: ElementRef;
  @ViewChild('passwordEm', { static: false }) passwordEm: ElementRef;

  store_code: string = null;

  public errorMessage: any = {};

  previousUrl = 'foc/top';
  companyCode = null;
  loginId = null;
  password = null;
  save_company_info = false;
  foc_compnay_login_info = this.sessionSvc.get('foc_compnay_login_info', true);
  shaking = false;
  is_IE = false;
  constructor(
    private loaderSvc: LoaderService,
    private httpClientService: HttpClientService,
    private sessionSvc: SessionService,
    private staffSvc: StaffService,
    private baseSvc: BaseService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit() {
    this.sessionSvc.clear('staff_login_info');
    const userAgent = window.navigator.userAgent.toLowerCase();
    if (userAgent.indexOf('msie') > 0 || userAgent.indexOf('trident') > 0) {
      this.sessionSvc.save('message', { type: 'warning', title: '本システムはIE非対応です。他のブラウザーをご利用ください。', force: true });
      this.is_IE = true;
      return;
    } else if (userAgent.indexOf('edge') > 0) {
      this.sessionSvc.save('message', { type: 'warning', title: '本システムは旧Edge非対応です。他のブラウザーをご利用ください。', force: true });
      this.is_IE = true;
      return;
    }
    this.activatedRoute.queryParamMap.subscribe((params: ParamMap) => {
      if (params.has('previousUrl')) {
        this.previousUrl = params.get('previousUrl');
      }
    });
    if (this.foc_compnay_login_info) {
      this.companyCode = this.foc_compnay_login_info.companyCode;
      this.loginId = this.foc_compnay_login_info.loginId;
      this.save_company_info = this.foc_compnay_login_info.save_company_info;
    }
    setTimeout(() => {
      $('.ui.checkbox').checkbox();
    }, 100);
  }

  checkLoginButtonState(): boolean {
    return !!this.store_code;
  }

  onKeyUp(event) {
    if (event.keyCode === 13) {
      this.login();
    }
  }
  login() {
    if (this.is_IE) {
      return;
    }
    if (!this.validate()) {
      this.shake_form();
      return;
    }
    this.saveLoginInfo();
    const loginRequest = new LoginPostRequest();
    loginRequest.company_code = this.companyCode;
    loginRequest.login_id = this.loginId;
    loginRequest.password = this.password;
    this.loaderSvc.call();
    this.httpClientService
      .postLogin(loginRequest)
      .then(async (response) => {
        Utils.log(response);
        if (document.execCommand) {
          document.execCommand('ClearAuthenticationCache', false);
        }
        const login_info = { token: response, staff: null };
        this.sessionSvc.save('staff_login_info', login_info);
        await this.httpClientService.getLoginStaff().then(async (staffResponse) => {
          Utils.log(staffResponse);
          login_info.staff = staffResponse;
          this.sessionSvc.save('staff_login_info', login_info);
          const company = this.getLoginCompany(login_info.staff.base);
          if (await this.getMaster(company)) {
            this.router.navigate([this.previousUrl]);
          } else {
            this.sessionSvc.clearAll();
          }
          this.loaderSvc.dismiss();
        }).catch(error => {
          this.loginError('スタッフ情報の取得が失敗しました。');
        });
      })
      .catch((error) => {
        if (error && error.detail) {
          this.loginError('会社コード、ログインID、パスワードの組合せが正しくありません。');
        }
        this.loaderSvc.dismiss();
      });

  }
  getLoginCompany(base) {

    if (!base) {
      return base;
    }
    if (base.base_type <= 1) {
      return base;
    } else {
      return this.getLoginCompany(base.parent);
    }
  }

  async getMaster(base) {

    // 全てのマスタデータを並列で取得
    const results = await Promise.all([
      this.baseSvc.getData().catch(error => {
        Utils.log('baseSvc.getData error:', error);
        return null;
      }),
      this.staffSvc.getData(base.id).catch(error => {
        Utils.log('staffSvc.getData error:', error);
        return null;
      }),
      this.httpClientService.getHoyoStyleList().catch(error => {
        Utils.log('getHoyoStyleList error:', error);
        return null;
      }),
      this.httpClientService.getSekoStyleList().catch(error => {
        Utils.log('getSekoStyleList error:', error);
        return null;
      }),
      this.httpClientService.getScheduleList().catch(error => {
        Utils.log('getScheduleList error:', error);
        return null;
      }),
      this.httpClientService.getFuhoSampleList().catch(error => {
        Utils.log('getFuhoSampleList error:', error);
        return null;
      }),
      this.httpClientService.getHoyoSampleMasterList().catch(error => {
        Utils.log('getHoyoSampleMasterList error:', error);
        return null;
      }),
      this.httpClientService.getServiceList().catch(error => {
        Utils.log('getServiceList error:', error);
        return null;
      }),
      this.httpClientService.getTaxList().catch(error => {
        Utils.log('getTaxList error:', error);
        return null;
      }),
      this.httpClientService.getHenreihinParameter().catch(error => {
        Utils.log('getHenreihinParameter error:', error);
        return null;
      })
    ]).catch(error => {
      Utils.log('getMaster error:', error);
      this.loginError('マスタ情報の取得が失敗しました。');
      return [null, null, null, null, null, null, null, null, null, null];
    });

    const [baseData, staffData, hoyoStyle, sekoStyle, schedule, fuhoSample, hoyoSampleMst, service, tax, henreiParam] = results;

    // 拠点情報のチェック
    if (!baseData) {
      this.loginError('拠点情報の取得が失敗しました。');
      return false;
    }

    // スタッフ情報のチェック
    if (!staffData) {
      this.loginError('スタッフ情報の取得が失敗しました。');
      return false;
    }

    // マスタデータをセッションに保存
    if (hoyoStyle) {
      this.sessionSvc.save('hoyo_style_list', hoyoStyle);
    }
    if (sekoStyle) {
      this.sessionSvc.save('seko_style_list', sekoStyle);
    }
    if (schedule) {
      this.sessionSvc.save('schedule_list', schedule);
    }
    if (fuhoSample) {
      this.sessionSvc.save('fuho_sample_list', fuhoSample);
    }
    if (hoyoSampleMst) {
      this.sessionSvc.save('hoyo_sample_mst_list', hoyoSampleMst);
    }
    if (service) {
      this.sessionSvc.save('service_list', service);
    }
    if (tax) {
      this.sessionSvc.save('tax_list', tax);
    }
    if (henreiParam) {
      this.sessionSvc.save('henrei_param', henreiParam);
    }

    return true;

  }
  validate() {
    if (!this.companyCode) {
      this.companyCodeEm.nativeElement.focus();
      return false;
    }
    if (!this.loginId) {
      this.loginIdEm.nativeElement.focus();
      return false;
    }
    if (!this.password) {
      this.passwordEm.nativeElement.focus();
      return false;
    }
    return true;
  }
  shake_form() {
    this.shaking = true;
    setTimeout(() => {
      this.shaking = false;
    }, 300);
    // $('.login_form')
    //   .transition('shake')
  }

  loginError(title, msg = null) {
    const message = {
      type: 'error',
      title: title,
      msg: msg
    };
    this.sessionSvc.save('message', message);
    this.loaderSvc.dismiss();

  }

  saveLoginInfo() {
    if (this.save_company_info) {
      this.foc_compnay_login_info = {
        companyCode: this.companyCode,
        loginId: this.loginId,
        save_company_info: this.save_company_info
      };
      this.sessionSvc.save('foc_compnay_login_info', this.foc_compnay_login_info, true);
    } else {
      this.sessionSvc.clear('foc_compnay_login_info', true);

    }
  }
}
